import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('LocationCode?page=' + page, {params});
    }, 
    getByPlant(plant, params) {
        return Service().get('LocationCode/get-by-plant/' + plant, {params});
    },
    show(id) {
        return Service().get('LocationCode/show/'+id);
    },    
    create(params) {
        return Service().post('LocationCode/create', params);
    },
    update(id, params) {
        return Service().post('LocationCode/update/'+id, params);
    },
    delete(id) {
        return Service().post('LocationCode/delete/'+id);
    }
}